// extracted by mini-css-extract-plugin
module.exports = {"navigation":"styles_navigation__CL5h_","background_is_white":"styles_background_is_white__V_mut"};